<template>
<v-container class="need-help pa-lg-6 pa-4">
  <h1 style="color: black !important;" class="text-center">{{HelpSection.title}}
  </h1>
  <v-layout wrap>
    <v-col cols="12" sm="12" md="4" class="" v-for="(item, index) in HelpSection.items" :key="index">
      <v-hover v-slot="{ hover }">
        <router-link style="text-decoration: none; color: black;" :to="item.routerTarget">
          <v-card :elevation="hover ? 10 : 2" :class="{ 'on-hover': hover }" tile outlined>
            <v-img :src="letterIcon(item.img)" height="20vh">
            </v-img>
            <v-card-title>{{item.title}}
              <v-icon class="" color="light-blue">mdi-chevron-right</v-icon>
            </v-card-title>
          </v-card>
        </router-link>
      </v-hover>
    </v-col>
  </v-layout>
</v-container>
</template>

<script>
import HelpSection from '@/copy/HelpSection';

export default {
  name: 'NeedHelp',
  data() {
    return {
      HelpSection,
    }
  },
  methods: {
    letterIcon: function(path) {
      return require("@/" + path);
    },
  },
};
</script>
